import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { DocumentService, DataImportService } from '@samc/centricity-core';
import { AjaxHelper, Guid, errToMessage, getToken, getCurrentUser } from '@samc/common';
import { ILegacyImportError } from '@/Interfaces';
import { download } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegacyPackageImportModal',
  props: {
    documentUrl: { type: String, required: true },
    dataImportUrl: { type: String, required: true },
    legacyUrl: { type: String, required: true },
    verificationToken: { type: String, required: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({ (event: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  documentUrl: string,
  dataImportUrl: string,
  legacyUrl: string,
  verificationToken: string
};




const file = ref<File | null>(null);
const errors = ref<ILegacyImportError[]>([]);
const grid = ref<HTMLSamcGridElement | null>(null);

const downloadTemplate = async () => {
  try {
    const ajaxHelper = new AjaxHelper(props.legacyUrl, props.verificationToken, null, getToken());
    window.loading?.('Downloading Template...');

    const data = await ajaxHelper.getData<Blob>('package/template', {}, { responseType: 'blob' });
    download(data, 'LegacyPackageTemplate.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  } catch (err) {
    window.showAlert?.({
      type: 'error',
      title: 'Failed to download template',
      description: 'For more detailed information, please contact support team.',
      errors: errToMessage(err),
      closingOption: 'holdOpen'
    });
  } finally {
    window.loading?.();
  }
};

const uploadFile = async () => {
  if (file.value === null)
    return;

  try {
    const documentService = new DocumentService(new AjaxHelper(props.documentUrl, props.verificationToken, null, getToken()));
    const dataImportService = new DataImportService(new AjaxHelper(props.dataImportUrl, props.verificationToken, null, getToken()));
    const ajaxHelper = new AjaxHelper(props.legacyUrl, props.verificationToken, null, getToken());
    const user = getCurrentUser();
    const sourceId = Guid.create().toString();

    window.loading?.('Uploading File...');
    const mimetype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const document = await documentService.createDocument(file.value, sourceId, mimetype, 'Legacy Package Import Template');

    window.loading?.('Extracting Data From File...');
    const result = await dataImportService.addExcelFileRawData(
      document.documentId, 0, '', document.fileName, user?.name ?? '', 1, 2, 1, 1, { importProcessId: '22' }
    );

    window.loading?.('Importing Template...');
    const request = { metaId: result.rawMetaData.id, sourceId: result.file.id };
    errors.value = await ajaxHelper.postData<ILegacyImportError[]>('package/template', {}, request);

    if (errors.value.length === 0) {
      window.showAlert?.success('Upload Template Success', 'Successfully uploaded legacy package/acquisition import template.');
      close();
    }
  } catch (err) {
    window.showAlert?.({
      type: 'error',
      title: 'Failed to upload file',
      description: 'For more detailed information, please contact support team.',
      errors: errToMessage(err),
      closingOption: 'holdOpen'
    });
  } finally {
    window.loading?.();
  }
};

const fileChanged = async (evt: CustomEvent<File | File[] | null | undefined>) => {
  if (evt.detail !== null && evt.detail !== undefined && !Array.isArray(evt.detail)) {
    file.value = evt.detail;
  } else {
    file.value = null;
  }
};

const close = () => {
  emits('close');
};

watch(grid, grid => {
  if (grid !== null) {
    grid.rowData = errors.value;
  }
})

return { __sfc: true,props, emits, file, errors, grid, downloadTemplate, uploadFile, fileChanged, close }
}

})